import { dataHooks } from '../../../../libs/dataHooks';

export const showFiltersButtonDataHooks = dataHooks<{
  appliedFiltersCount: {};
}>('filters');
